import {
  Component,
  OnDestroy,
  OnInit,
  CUSTOM_ELEMENTS_SCHEMA,
  inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { TextViewerService } from '../../../core/services/text-viewer.service';

@Component({
  selector: 'app-text-viewer-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './text-viewer-modal.component.html',
  styleUrls: ['./text-viewer-modal.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TextViewerModalComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private readonly textViewerService = inject(TextViewerService);

  open = false;
  title = '';
  text = '';

  ngOnInit(): void {
    this.textViewerService.request$
      .pipe(takeUntil(this.destroy$))
      .subscribe((request) => {
        if (!request) {
          this.reset();
          return;
        }
        this.open = true;
        this.title = request.title;
        this.text = request.text;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onOverlayClick(): void {
    this.close();
  }

  close(): void {
    this.textViewerService.close();
  }

  private reset(): void {
    this.open = false;
    this.title = '';
    this.text = '';
  }
}
